import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { NotificationsPage } from 'pages/settings/pages/notifications/ui/NotificationsPage'

export const NotificationsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route index element={<NotificationsPage />} />
    </RoutesWithNotFound>
  )
}
